import { createRoot } from "react-dom/client";
import { fn } from "n24-ui";
import { RootStore, StoreContextProvider } from "../stores/root.store";
import { LicenseInfo } from "@mui/x-license";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import dateFormat from "date-fns/locale/en-GB";
import VideoShare from "../views/administration/video/Video.share";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";
import theme from "../theme";

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_PRO_LICENSE_KEY || "");

fn.addCSRFTokenToAxiosRequests();
fn.addAxiosInterceptorForRailsParams();

const root = createRoot(document.getElementById("root") as Element);
root.render(
  <StoreContextProvider value={new RootStore()}>
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={dateFormat}
    >
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <ThemeProvider theme={theme.light}>
          <CssBaseline />
          <VideoShare />
        </ThemeProvider>
      </SnackbarProvider>
    </LocalizationProvider>
  </StoreContextProvider>,
);
